var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('loading') : _vm._e(), _vm._m(0), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("名字")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.name,
      expression: "customer.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.customer.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "name", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("手機")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.mobile_phone,
      expression: "customer.mobile_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.customer.mobile_phone
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "mobile_phone", $event.target.value);
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("生日")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.birthday,
      expression: "customer.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.customer.birthday
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "birthday", $event.target.value);
      }
    }
  })])]), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-Mail")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.email,
      expression: "customer.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.customer.email
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customer, "email", $event.target.value);
      }
    }
  })])])]), _vm.selects.areas ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("選擇服務地區")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.location_area,
      expression: "customer.location_area"
    }],
    staticClass: "form-control",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.customer, "location_area", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.areaSelected]
    }
  }, _vm._l(_vm.selects.areas, function (area, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(area))]);
  }), 0)])])]) : _vm._e(), _vm.selects.cities ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("選擇服務縣市")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.location_city,
      expression: "customer.location_city"
    }],
    staticClass: "form-control",
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.customer, "location_city", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.citySelected]
    }
  }, _vm._l(_vm.selects.cities, function (city, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(city))]);
  }), 0)])])]) : _vm._e(), _vm.selects.serviceTypes ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("選擇服務類型")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.customer.service_type,
      expression: "customer.service_type"
    }],
    staticClass: "form-control",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.customer, "service_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.selects.serviceTypes, function (serviceType, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(serviceType))]);
  }), 0)])])]) : _vm._e(), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "variant": "light",
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 取消 ")])], 1), _c('div', {
    staticClass: "col-6"
  }, [_c('b-button', {
    staticClass: "btn-block",
    attrs: {
      "variant": "secondary",
      "disabled": _vm.buttonLoading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 送出 ")])], 1)])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-center mt-2"
  }, [_c('h2', [_vm._v("填寫顧客資料")])]);
}]

export { render, staticRenderFns }